module.exports = flarum.core.compat['components/EventPost'];